import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class MovimientosExportador {
  getMovimientosDiarioExportador (fechaD, exportador, cereal, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden":["fecha"]'
    const filtro = `{"clave": {"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}", "cereal": "${cereal}", "exportador": "${exportador}"}, ${orden}}`
    const promise = axios.get(`consulta_reporte_almacenaje?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  getTransferenciasExportador () {
    const axios = getAxiosInstance()
    const orden = '{"orden":["fecha"]}'
    const promise = axios.get(`consulta_transferencia_entre_exportadores_listado?r=${orden}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getTransferenciasPorExportador (exportador) {
    const axios = getAxiosInstance()
    const orden = '"orden":["fecha"]'
    const filtro = `{"clave": {"exportador": "${exportador}"}, ${orden}}`
    const promise = axios.get(`consulta_transferencia_entre_exportadores_por_exp?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  deleteTransferencia (id) {
    const axios = getAxiosInstance()
    const filtro = `{"clave": {"id": ${id}}}`
    const promise = axios.delete(`transferencia_entre_exportadores?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  adaptToBackend (values = {}) {
    const {
      cereal,
      cerealVariedad,
      exportadorOrigen,
      exportadorDestino,
      cantidad
    } = values

    return {
      cereal: cereal,
      cerealVariedad: cerealVariedad,
      exportadorOrigen: exportadorOrigen,
      exportadorDestino: exportadorDestino,
      cantidad: cantidad
    }
  }

  updateTransferenciaExportadores (id, values) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackend(values)
    const promise = axios.put(`/transferencia_entre_exportadores`, { valores: { ...valores }, clave: { id: id } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }
}

export default MovimientosExportador
